import { render, staticRenderFns } from "./master.vue?vue&type=template&id=421119d1&"
import script from "./master.vue?vue&type=script&lang=js&"
export * from "./master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421119d1')) {
      api.createRecord('421119d1', component.options)
    } else {
      api.reload('421119d1', component.options)
    }
    module.hot.accept("./master.vue?vue&type=template&id=421119d1&", function () {
      api.rerender('421119d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/master.vue"
export default component.exports